import {ArticleInterface} from '@wp-content-publisher/typings-lib';
import {apiRequest} from '../../../shared/utils/api-request.helper.ts';


export const getArticleList = async (queryParams?: URLSearchParams): Promise<ArticleInterface[]> =>
    await apiRequest({
        url: '/articles',
        queryParams,
        options: {method: 'GET'}
    });